import { useState } from "react";
import { BookOpen } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgSrc } from "@/lib/api";
import { SocialLinks } from "./SocialLinks";

export const BioButton = ({ m, testPrefix, size = "h-10" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid={`${testPrefix}-bio-btn`}
        onClick={() => setOpen(true)}
        className={`${size} inline-flex items-center gap-2 px-4 border border-[#56ED4A] bg-black/60 backdrop-blur-md text-[#56ED4A] font-mono text-xs uppercase tracking-[0.2em] font-semibold hover:bg-[#56ED4A] hover:text-black transition-colors`}
      >
        <BookOpen size={14} /> Bio
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`${testPrefix}-bio-dialog`} className="bg-[#121216] border-white/10 w-[94vw] max-w-3xl max-h-[90vh] overflow-y-auto p-0">
          <div className="grid md:grid-cols-[0.9fr_1.1fr]">
            <div className="relative bg-black aspect-[4/5] md:aspect-auto md:min-h-[460px] overflow-hidden">
              {m.image_url ? (
                <>
                  <img src={imgSrc(m.image_url)} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-125 blur-2xl opacity-40" />
                  <img src={imgSrc(m.image_url)} alt={m.name} className="absolute inset-0 w-full h-full object-contain object-top" />
                </>
              ) : (
                <img src="/logo-mark.png" alt="" className="absolute inset-0 m-auto w-1/2 h-1/2 object-contain" />
              )}
            </div>
            <div className="p-6 md:p-8 flex flex-col">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#56ED4A]">{m.role}</p>
              <DialogTitle className="font-display uppercase text-5xl md:text-6xl leading-[0.9] mt-2 tracking-normal break-words">{m.name}</DialogTitle>
              <p data-testid={`${testPrefix}-bio-text`} className="mt-5 text-zinc-300 leading-relaxed whitespace-pre-line">
                {m.bio || "Bio coming soon."}
              </p>
              <div className="mt-auto pt-6"><SocialLinks links={m.links} testPrefix={`${testPrefix}-bio`} /></div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
